import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import omit from 'lodash/omit';
import uniq from 'lodash/uniq';
export var registerFields = function registerFields(_ref) {
  var changeId = _ref.changeId,
    fieldsToBeRegistered = _ref.fieldsToBeRegistered,
    appId = _ref.appId;
  return function (_ref2) {
    var _registeredFields$app, _appFields$changeId;
    var setState = _ref2.setState,
      getState = _ref2.getState;
    if (!Array.isArray(fieldsToBeRegistered)) {
      return;
    }
    var _getState = getState(),
      registeredFields = _getState.registeredFields;
    var appFields = (_registeredFields$app = registeredFields[appId]) !== null && _registeredFields$app !== void 0 ? _registeredFields$app : {};
    var appChangeIdFields = (_appFields$changeId = appFields[changeId]) !== null && _appFields$changeId !== void 0 ? _appFields$changeId : [];
    var nextRegisteredFields = _objectSpread(_objectSpread({}, registeredFields), {}, _defineProperty({}, appId, _objectSpread(_objectSpread({}, appFields), {}, _defineProperty({}, changeId, uniq([].concat(_toConsumableArray(appChangeIdFields), _toConsumableArray(fieldsToBeRegistered)))))));
    setState({
      registeredFields: nextRegisteredFields
    });
  };
};
export var unregisterFields = function unregisterFields(_ref3) {
  var changeId = _ref3.changeId,
    appId = _ref3.appId;
  return function (_ref4) {
    var _registeredFields$app2;
    var setState = _ref4.setState,
      getState = _ref4.getState;
    var _getState2 = getState(),
      registeredFields = _getState2.registeredFields;
    var registeredAppFields = (_registeredFields$app2 = registeredFields[appId]) !== null && _registeredFields$app2 !== void 0 ? _registeredFields$app2 : {};
    var nextRegisteredAppFields = omit(registeredAppFields, changeId);
    setState({
      registeredFields: _objectSpread(_objectSpread({}, registeredFields), {}, _defineProperty({}, appId, nextRegisteredAppFields))
    });
  };
};